import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";/**
 * A message container used to alert the user to an error.
 * Looks something like:
 *   [ (!) Your Message Here ]
 *
 */
import styled from '@emotion/styled'
import {Warning} from '@mui/icons-material'
import {PALETTE} from '../../styles/paletteV3'
import {Radius} from '../../types/constEnums'





const ErrorAlertWrapper = styled('div')({
  backgroundColor: PALETTE.TOMATO_100,
  borderRadius: Radius.TOOLTIP,
  display: 'flex',
  alignItems: 'center',
  fontSize: 14,
  marginBottom: 16,
  padding: '8px 16px',
  overflowX: 'auto'
})

const SpacedIcon = styled(Warning)({
  height: 18,
  width: 18,
  marginRight: 8
})

const ErrorAlert = ({message}) => {
  return (
    _jsxs(ErrorAlertWrapper, { role: "alert", children: [
      _jsx(SpacedIcon, {} )
      , _jsx('span', { children: message})
    ]})
  )
}

export default ErrorAlert
